// @flow

import { takeEvery }                  from 'redux-saga/effects';
import type { LocationChangedAction } from '../../modules/connected-react-router/types';

// @todo $FlowFixMe
function* watchForLocationChange() {

  // @todo $FlowFixMe
  yield takeEvery('@@router/LOCATION_CHANGE', navigateToTop);

}


function navigateToTop(action: LocationChangedAction) {
  window.scrollTo(0, 0);
}


export default watchForLocationChange;



// WEBPACK FOOTER //
// ./src/sagas/router/topOfPageOnNavigate.js